module.exports = __webpack_public_path__ + "media/images/b2b_admin/employees_mini_screen-86445794975f02634554084c5eea2401.png";